module.exports = __webpack_public_path__ + "img/document.173ef36b.svg";